export function getOpenSelectMenuForTrigger(trigger, doc) {
    const next = trigger.nextElementSibling;
    if (next &&
        typeof next.matches === 'function' &&
        next.matches('ul.select.dropdown-menu') &&
        next.offsetParent !== null) {
        return next;
    }
    const menus = Array.from(doc.body.querySelectorAll('ul.select.dropdown-menu'));
    for (let i = menus.length - 1; i >= 0; i--) {
        const menu = menus[i];
        if (menu.offsetParent !== null)
            return menu;
    }
    return null;
}
